import React from "react";
import styles from "./styles.module.css";
const Banner = ({ image }) => {
  return (
    <div className={styles.banner}>
      <img src={image} alt="post banner" />
    </div>
  );
};

export default Banner;
